/*
 * @Author: 01399133
 * @Date: 2021-06-07 17:40:02
 * @LastEditors: 01387189
 * @LastEditTime: 2021-07-15 16:19:39
 * @Description: file content
 */
import Vue from "vue";
import Router from "vue-router";
import productRouter from "./product";
import paymentRouter from "./payment";
import transactionRouter from "./transaction";
import invoiceRouter from "./invoice";
import contractRouter from "./contract";
import GrayEnvUtil from "../libs/esg-acsp-core-vue-lib/utils/GrayEnvUtil";
import { jumpBLogin } from "@/utils/utils";

//解决重复push相同路由报警告的bug
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "store",
    meta: {
      title: "首页-顺丰科技数字商店",
    },
    component: () => import(/* webpackChunkName:'home' */ "@/pages/index"),
  },
  {
    path: "/login",
    name: "login",
    redirect: () => {
      // 进入B端登录页
      jumpBLogin();
    },
    meta: {
      title: "登录-顺丰科技数字商店",
    },
    component: () => import(/* webpackChunkName:'home' */ "@/pages/login"),
  },
  {
    path: "/middle",
    name: "middle",
    meta: {
      title: "登录-顺丰科技数字商店",
    },
    component: () => import(/* webpackChunkName:'home' */ "@/pages/middle"),
  },
  {
    path: "*",
    name: "404",
    component: () => import(/* webpackChunkName:'404' */ "@/pages/404"),
  },
  {
    path: "/",
    name: "cent",
    component: () => import(/* webpackChunkName:'cent' */ "@/pages/cent"),
    children: [...transactionRouter, ...invoiceRouter, ...contractRouter],
  },
  ...productRouter,
  ...paymentRouter,
];

const routerConfig = {
  mode: "history",
  base: window.__POWERED_BY_QIANKUN__
    ? `/${GrayEnvUtil.isInGray() ? "g" : "web"}/laas/store/`
    : process.env.VUE_APP_ROUTER_BASE,
  routes,
};

const router = new Router(routerConfig);

export default router;
